import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SiteContext = createContext({ settings: null, projects: [], loaded: false, reload: () => {} });

export const SiteProvider = ({ children }) => {
  const [state, setState] = useState({ settings: null, projects: [], loaded: false });

  const load = async () => {
    try {
      const [s, p] = await Promise.all([api.get("/settings"), api.get("/projects")]);
      setState({ settings: s.data || null, projects: Array.isArray(p.data) ? p.data : [], loaded: true });
    } catch (e) {
      setState((prev) => ({ ...prev, loaded: true }));
    }
  };

  useEffect(() => {
    load();
  }, []);

  return <SiteContext.Provider value={{ ...state, reload: load }}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
